<template>
  <div class="home">
    
		
	
		<component-viewSite :idMeterAccount="64"></component-viewSite>

  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import viewSite from '../components/ViewSite.vue'

export default {
   name: 'home',
   components: {
    'component-viewSite' : viewSite
   },
   data: () => ({ 
       'employee' : "",
        'userObject' : null
   }),

   methods : {
       
   },
   created: function () {
       console.log("Home created");
   }
}
</script>
